module.exports = __webpack_public_path__ + "static/duotone-4ddad05541e4da75769a955cb5123aae.png";